import ChartPie from "./chartPie.js";
export default ChartPie;